/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaRemove
 */
export interface MfaRemove {
    /**
     * 
     * @type {boolean}
     * @memberof MfaRemove
     */
    success: boolean;
}

/**
 * Check if a given object implements the MfaRemove interface.
 */
export function instanceOfMfaRemove(value: object): value is MfaRemove {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function MfaRemoveFromJSON(json: any): MfaRemove {
    return MfaRemoveFromJSONTyped(json, false);
}

export function MfaRemoveFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaRemove {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function MfaRemoveToJSON(json: any): MfaRemove {
    return MfaRemoveToJSONTyped(json, false);
}

export function MfaRemoveToJSONTyped(value?: MfaRemove | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

